/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useState } from "react";
import { Box, Button, Paper } from "@mui/material";
import contractLawDetailsStyles from "./contractLawDetailsStyles";
import GeneralContractLawCaseDetails from "./GeneralContractLawCaseDetails";
import ExpandedGeneralContractLawCaseDetails from "./ExpandedGeneralContractLawCaseDetails";
import Grid from "@mui/material/Grid";
import ContentBoxHead from "../../../Box/ContentBox/ContentBoxHead";
import IconData from "../../../../assets/icons/generic/toggleable/IconData";
import Typography from "@mui/material/Typography";
import CaseDetailsItem from "../../Common/CaseDetailsItem/CaseDetailsItem";
import { AbstractCase } from "../../../../types/Entities/AbstractCase";

type ContractLawDetailsSectionProps = {
  contractLawCase: AbstractCase;
};

const ContractLawDetailsSection = ({ contractLawCase }: ContractLawDetailsSectionProps) => {
  const [showExpandedInfo, setShowExpandedInfo] = useState(false);
  return (
    <Paper elevation={4} sx={contractLawDetailsStyles.container}>
      <Grid container sx={contractLawDetailsStyles.headlineContainer}>
        <Grid item>
          <ContentBoxHead headline={"Meine Angaben"} Icon={IconData} />
        </Grid>
      </Grid>
      <GeneralContractLawCaseDetails contractLawCase={contractLawCase} />
      {showExpandedInfo && contractLawCase.caseCategory === "advisory" && (
        <>
          <Typography variant={"h6"} sx={contractLawDetailsStyles.subheader}>
            Beschreibung der Situation
          </Typography>
          <Box sx={contractLawDetailsStyles.divider} />
          <Grid container>
            <CaseDetailsItem caseData={contractLawCase} fieldPath={"personalTextMessage"} />
          </Grid>
        </>
      )}
      {showExpandedInfo && contractLawCase.caseCategory !== "advisory" && <ExpandedGeneralContractLawCaseDetails contractLawCase={contractLawCase} />}
      <Button fullWidth color={"primary"} onClick={() => setShowExpandedInfo(!showExpandedInfo)}>
        {!showExpandedInfo ? "Alle Anzeigen" : "Weniger Anzeigen"}
      </Button>
    </Paper>
  );
};

export default ContractLawDetailsSection;
